"use strict";

exports.__esModule = true;
var _RealtimeConnectionController = require("./RealtimeConnectionController");
Object.keys(_RealtimeConnectionController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RealtimeConnectionController[key]) return;
  exports[key] = _RealtimeConnectionController[key];
});